import routeFactory from "@/routes";
import GlobalLoadingService from "@/utils/globalLoading";
import MessageService from "@/utils/message";
import tokenService from "@/utils/tokenService";
import uuidUtils from "@/utils/uuidUtils";
import {message} from "ant-design-vue";
import axios from 'axios';
import moment from 'moment';

const flag = JSON.parse(process.env.VUE_APP_ROUTE_CONFIG_LOADING_TRUE || "false")

// 创建axios实例
const httpService = axios.create({
    baseURL: process.env.VUE_APP_API_GATEWAY_BASE_URL, // api 的 base_url
    timeout: parseInt(process.env.VUE_APP_REQUEST_TIMEOUT + "") // 请求超时时间
})

const convertDateFormat = (data: any) => {
    for (const key in data) {
        const info = data[key];
        if (info == null) {
            continue;
        }
        if (typeof info == "object") {
            if (info._isAMomentObject) {
                let date = moment(info).utcOffset(480).format("YYYY-MM-DD HH:mm:ss");
                data[key] = date;
            }
        }
    }
    return data;
}

httpService.interceptors.request.use(
    config => {
        //console.log("config",config);
        config.params = config.params ? config.params : {};

        config.params.loadingKey = uuidUtils.guid();
        GlobalLoadingService.openLoading(config.params.loadingKey);
        config.headers.Authorization = tokenService.getToken();

        const scopeToken = tokenService.getScopeToken();
        if (scopeToken !== null) {
            config.headers.ScopeAuthorization = scopeToken;
        }
        if (config.data != null) {
            config.data = convertDateFormat(config.data);
        }
        return config;
    },
    err => {
        GlobalLoadingService.openLoading();
        return Promise.reject(err);
    }
)


httpService.interceptors.response.use(
    response => {
        //console.log("response",response);
        //console.log("response.config.params",response.config.params);
        if (response.config && response.config.params) {
            GlobalLoadingService.closeLoading(response.config.params.loadingKey);
        }

        const result = response.data;

        if (result.status !== undefined && result.status !== 200) {
            message.error("调用后台接口出错，错误代码为:" + result.status + ",错误信息为:" + result.message);
            return Promise.reject(result.status);
        }
        return response.data;
    }, error => {
        if (error?.response?.config && error?.response?.config?.params) {
            GlobalLoadingService.closeLoading(error.response.config.params.loadingKey);
        } else {
            // 第二个参数表示是否强制关闭
            GlobalLoadingService.closeLoading('', true);
        }
        message.error("调用后台接口出错，错误代码为:" + error.response.data.status + ",错误信息为:" + error.response.data.message);
        if (error.response.config?.url === "/auth/jwt/token") {
            return Promise.reject(error.response.status);
        }
        if (error.response.data.status === 40301) {
            if (tokenService.getToken()) {
                MessageService.warn("登录已过期请重新登录！");
            } else {
                MessageService.warn("请先登录才能访问此界面！");
            }
            setTimeout(() => {
                if (flag) {
                    routeFactory.getRouter().push("/logout")
                } else {
                    routeFactory.getRouter().push("/login")
                }
            }, 500);
        }


        return Promise.reject(error.response?.status);
    }
)


export default httpService

